export default __webpack_public_path__ + "static/media/PPT_card.6daa1874.svg";